import _ from "lodash";
import React from "react";

export function highlightSearchTerm(html: string, searchTerm: string) {
    if (!html) {
        return <span/>;
    }
    const regex = new RegExp(`(${_.escapeRegExp(searchTerm).split(/\s+/).join('|')})`, 'gi');
    const highlighted = {__html: html.replace(regex, '<mark key={i} data-testid=\'highlightedText\'>$1</mark>')}
    return <span dangerouslySetInnerHTML={highlighted}></span>;
}